import config from '@/config/index';
import {
  MAX_RECENTLY_PLAYED_GAMES,
  MIN_RECENTLY_PLAYED_GAMES,
} from '@/logic/main/constants';
import { LogicContext } from '@/logic/main/types';
import {
  divideGameListToSlides,
  mapGamesWithJackpotsV2,
} from '@/logic/main/utils';
import { RECENTLY_PLAYED_CATEGORY_ID } from '@/model/constants';

export const fetchRecentlyPlayedContent = async (context: LogicContext) => {
  const { user, controllersData, rpFirstLoad = true } = context;
  const gameDetailsInfo = config.features.gameDetails.mode === 'enabled';

  const { recentlyPlayedGamesList = [], loggedIn } = user;

  if (!controllersData.recentlyPlayed) {
    return {
      updates: [],
    };
  }

  /**
   * The RP section should be set correctly on the CMS side so that it is displayed only for logged in users.
   * Since this section may occasionally be incorrectly published,
   * we check the user's login status on the application side
   * and force hiding this category because otherwise the application behaves in non-compliant manner.
   */
  const rpVisible =
    loggedIn &&
    recentlyPlayedGamesList.length >= MIN_RECENTLY_PLAYED_GAMES &&
    !context.isGameModalForMobileOpened;

  const { components } = controllersData.recentlyPlayed;

  const rpGamesWithJackpot = mapGamesWithJackpotsV2(
    recentlyPlayedGamesList,
    context.currentJackpotsV2
  );

  const updates = components.map(([id, cmp]) => {
    const {
      view_all_button,
      view_all_button_visible,
      title,
      description,
      type,
      staticTexts,
      game_number_limit,
    } = cmp.properties;

    const rpCategory = {
      id: RECENTLY_PLAYED_CATEGORY_ID,
      description,
      view_all_button,
      view_all_button_visible,
      title,
      games: rpGamesWithJackpot,
      gameDetailsInfo,
      staticTexts,
      type,
      ...(type === 'Grid'
        ? {
            component_type: 'game_collection',
            slides: [
              {
                gameList: rpGamesWithJackpot,
                type: 'Collection',
                gamesLimit: game_number_limit
                  ? game_number_limit
                  : MAX_RECENTLY_PLAYED_GAMES,
              },
            ],
          }
        : {
            component_type: 'game_grid',
            slides: divideGameListToSlides({
              gameList: rpGamesWithJackpot,
              slideType: type,
            }),
          }),
    };

    return {
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: {
          category: rpVisible ? rpCategory : undefined,
          animation: rpFirstLoad,
          visible: rpVisible,
        },
      },
    };
  });

  return {
    updates,
  };
};
